import { useEffect, useState } from "react";
import client from "@/api/client";

let cache = null;
let promise = null;
const listeners = new Set();

export function refreshUserNames() {
  cache = null;
  promise = null;
  return loadUserNames();
}

async function loadUserNames() {
  if (cache) return cache;
  if (!promise) {
    promise = client.get("/user-names").then((r) => {
      cache = r.data || {};
      listeners.forEach((cb) => cb(cache));
      return cache;
    }).catch(() => {
      cache = {};
      return cache;
    });
  }
  return promise;
}

/** Returns { map, nameFor(mobile) }. Loads once on mount, cached module-wide. */
export function useUserNames() {
  const [map, setMap] = useState(cache || {});
  useEffect(() => {
    let mounted = true;
    loadUserNames().then((m) => { if (mounted) setMap({ ...m }); });
    const cb = (m) => setMap({ ...m });
    listeners.add(cb);
    return () => { mounted = false; listeners.delete(cb); };
  }, []);
  return {
    map,
    nameFor: (mobile) => (mobile && map[mobile]) ? `${map[mobile]}` : (mobile || "—"),
  };
}
